export const CLOSED = 'closed'
export const RUNNING = 'running'
export const UPCOMMING = 'upcomming'

export const BUTTON_LABEL_MAP = {
  closed: 'Ver ahora',
  running: 'Ver ahora',
  upcomming: 'Inscribirme'
}
